


























































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import Editor from '@tinymce/tinymce-vue';

class sablon {
    sablon_id!:number;
    code!:string;
    sms_body!:string;
    title!:string;
    body!:string;
}
@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id,Editor
    }
})
export default class Sablon extends  Vue{
    items : sablon[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "sablon";
    action:string = this.baseAction;
    data : sablon = new sablon();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "sablon_id"
        },
        {text: "Kod", value: "code"},
        {text: "Başlık", value: "title"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:sablon){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.sablon_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new sablon();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
